// extracted by mini-css-extract-plugin
export default {"TabsNav":"DevelopersPage_TabsNav__763xi","DocsLink":"DevelopersPage_DocsLink__+MSqj"};